/*eslint-disable */
import React, { Component } from "react";
import { Image, Grid } from "semantic-ui-react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { faFileInvoice } from "@fortawesome/free-solid-svg-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-theme-material.css";

import moment from 'moment';
import allAxiosCommonTA from "../../components/axiosComponent/allAxiosCommonTA";
import { consigneeConsignorCheck, DD_MM_yyyy } from '../../utils/constant'
import { invoiceColumnHeaders } from "../../utils/componentColumnConstants";
import TitleBarEwayBill from './ewayBill-title'
import EwayBillActions from "./ewayBillActions";
import ReadAxios from "../../components/axiosComponent/read";
import ExtendEwayBill from "./extend-ewayBill";
import LoadingPlaceholder from "../../components/placeholderComponent/loadingPlaceholder";
import axios from "axios";
import {LOCAL_STORAGE} from '../../utils/constant'
import {HEADERS, TITLE} from './ewayBillContants'
import cogoToast from "cogo-toast";


class Invoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      searchValue: '',
      selectedRows: [],
      isLoading: false,
      openModalExtend: false,
      extendData:{}
    };
  }

  componentDidMount() {
    this.getEwayBills()
  }

  getEwayBills = () => {
    allAxiosCommonTA({ url: `/Ewaybill/fetch`, method: "get"})
      .then((response) => {
        this.setState({ rowData: response.data.data, isLoading: true });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  handleSearch = (e) => {
    this.setState({ searchValue: e.target.value });
  }

  handleSelect = (data) => {
    let selectedrows = data.api.getSelectedRows();
    if (selectedrows.length !== this.state.selectedRows.length) {
      this.setState({ selectedRows: selectedrows });
    }
  }

  onGridReady = (prams) => {
    this.gridApi = prams.api;
    prams.columnApi.autoSizeAllColumns('', false);
    this.gridColumnApi = prams.columnApi;
    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds);
  }

  handleExtendModal = (data, value) =>{
    if(data){
        axios.get(`${process.env.REACT_APP_TA_API_URL}/Ewaybill/find/${data.eway_bill_no}?customer_no=${LOCAL_STORAGE.customerNo}&user_id=${LOCAL_STORAGE.userId}`, {
        headers: {
          Accept: "application/json",
          Authorization: `${LOCAL_STORAGE.userToken}`,
          "Access-Control-Allow-Origin": "*" 
        },
      }).then((result)=>{
        this.setState({extendData:result.data.resultSet , openModalExtend:value})
      }).catch((err)=>{
        err?.response?.data?.message ? cogoToast.error(err.response.data.message, {position: "top-right"}) : null
      })
    }else{
      this.setState({openModalExtend:value})
      window.location.reload()
    }
    
  }

  render() {
    var columnDefs = [
      {
        headerName: HEADERS.ewaybill_no||'E-way Bill No',
        field: "eway_bill_no",
        tooltipField: "eway_bill_no",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        enableRowGroup: true,
        enablePivot: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: HEADERS.Invoice||"Invoice No",
        field: "invoice_no",
        tooltipField: "invoice_no",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        enableRowGroup: true,
        enablePivot: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: HEADERS.lr_no||'LR No',
        field: "delivery.lr_no",
        tooltipField: "lr_no",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        enableRowGroup: true,
        enablePivot: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: HEADERS.ewaybill_expiry|| 'E-way Bill Expiry Date',
        field: "eway_bill_expirydate",
        tooltipField: "eway_bill_expiry_date",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        enableRowGroup: true,
        enablePivot: true,
        valueFormatter: function (params) {
          return params.value
            ? moment(params.value).format(DD_MM_yyyy)
            : "Na";
        },
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: HEADERS.delivery_reference_no || 'Delivery Reference No',
        field: "delivery.delivery_reference_no",
        tooltipField: "delivery_reference_no",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        enableRowGroup: true,
        enablePivot: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: HEADERS.order_reference_no || 'Order Reference No',
        field: "delivery.order.order_reference_no",
        tooltipField: "order_reference_no",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        enableRowGroup: true,
        enablePivot: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: HEADERS.status || "Status",
        field: "delivery.order.allotment_status.allotment_text",
        tooltipField: "eway_bill_status",
        sortable: true,
        filter: true,
        resizable: true,
        suppressSizeToFit: true,
        enableRowGroup: true,
        enablePivot: true,
        minWidth: 260,
        width: 260,
        maxWidth: 350,
      },
      {
        headerName: HEADERS.actions || "Extend",
        field:"extend_eway_bill",
        cellRenderer: "EwayBillActions",
        suppressToolPanel: true,
        pinned: "right",
        suppressSizeToFit: true,
        minWidth: 140,
        width: 140,
        maxWidth: 140,
      },

    ];

    var frameworkcomponent = {
      EwayBillActions:EwayBillActions
    }

    let rowItems = []

    if (this.state.rowData) {
      this.state.rowData.map((o, i) => {
        let temp = {}
        let delivery_reference_no = { delivery_reference_no: "NA" }
        let order_reference_no = { order_reference_no: "NA" }

        temp = o;
        if (temp?.delivery)
          temp.delivery.delivery_reference_no = o?.delivery?.delivery_reference_no || "NA"
        if (temp?.delivery?.order)
          temp.delivery.order.order_reference_no = o?.delivery?.order.order_reference_no || "NA"
        temp.invoice_no = o?.invoice_no || "NA"
        temp.invoice_date = o?.invoice_date ? o.invoice_date : "NA"
        temp.invoice_amount = o?.invoice_amount || "NA"
        temp.invoice_quantity = o?.invoice_quantity || "NA"
        temp.invoice_status = o?.delivery?.order?.allotment_status?.allotment_text || "NA"
        rowItems[i] = temp
      })
    }

    return (
      
      <React.Fragment>
        <div className="page-title-invoice">
          {/* <TitleBar
            title="Invoice" handleSearch={this.handleSearch}></TitleBar> */}
          <TitleBarEwayBill
            title={TITLE}
            showNewButton={true}
            LinkName = '/add-ewaybill'
             />
        </div>

        <div className="ag-theme-material agOver dispatch_bar"
        >
          {this.state.isLoading? 

          <AgGridReact
            suppressSizeToFit={true}
            domLayout="autoHeight"
            sideBar={this.state.sideBar}
            debounceVerticalScrollbar={true}
            rowGroupPanelShow={"always"}
            rowSelection="multiple"
            style={{ width: '100%', height: '50%' }}
            loadingOverlayComponent={this.state.loadingData}
            reactUi="true"
            animateRows="true"
            columnDefs={columnDefs}
            enableRangeSelection="true"
            rowData={rowItems}
            suppressRowClickSelection="true"
            quickFilterText={this.state.searchValue}
            pagination={true}
            paginationPageSize={10}
            onSelectionChanged={this.handleSelect}
            resizable="true"
            onGridReady={this.onGridReady}
            frameworkComponents={frameworkcomponent}
            handleExtendModal={this.handleExtendModal}
          />  :  <LoadingPlaceholder/> 
        }
        </div> 

        {this.state.openModalExtend===true && <ExtendEwayBill
        openBox={this.state.openModalExtend}
        handleClose={this.handleExtendModal}
        extendData = {this.state.extendData}
        />}
      </React.Fragment>
    );
  }
}


export default Invoice;